/**
 * Seção "Rastreio e previsão" da aba Satélite: a mesma hierarquia do painel
 * flutuante (`TrackingFloat`) — Rastreio e Previsão, os principais, e os
 * núcleos internos como opção secundária —, com os mesmos nomes e ordem, o
 * Rastreio da chuva (a outra aba do painel) e o atalho para ele, onde ficam a
 * antecedência da previsão e os sistemas do quadro.
 */
import { PanelRightOpen } from 'lucide-react';
import { useIsMobile } from '../ui/useMediaQuery';
import { Button, Section, Toggle } from '../ui/primitives';
import { BASE_RASTREIO_CHUVA } from '../rastreioChuva/api';
import { useRastreioChuvaStore } from '../rastreioChuva/store';
import { BASE_RASTREIO } from './api';
import { IconeRastreio } from './icone';
import { useTrackingStore } from './store';
import { DESCRICAO_DO_RASTREIO, descricaoDaPrevisao, InterruptorDosNucleos, ligarPrevisao } from './TrackingFloat';

export function TrackingSection() {
  const rastreio = useTrackingStore((s) => s.rastreio);
  const previsao = useTrackingStore((s) => s.previsao);
  const aberto = useTrackingStore((s) => s.painelAberto);
  const maior = useTrackingStore((s) => s.indice?.antecedencias[s.indice.antecedencias.length - 1]);
  const { setRastreio, setPainelAberto, setFolhaAberta } = useTrackingStore.getState();
  const mobile = useIsMobile();
  const chuva = useRastreioChuvaStore((s) => s.ligado);

  if (!BASE_RASTREIO) return null;

  return (
    <Section title="Rastreio e previsão" icon={IconeRastreio} storageKey="satelite-rastreio">
      <Toggle
        label="Rastreio das nuvens"
        checked={rastreio}
        onChange={setRastreio}
        description={`${DESCRICAO_DO_RASTREIO} Toque num sistema para ver a ficha dele.`}
      />
      <Toggle
        label="Previsão"
        checked={previsao}
        // A mesma porta do painel e da zona da linha do tempo.
        onChange={ligarPrevisao}
        description={descricaoDaPrevisao(maior)}
      />
      {/* Secundário, como no painel flutuante: o mesmo componente, o mesmo estado. */}
      <InterruptorDosNucleos />
      {BASE_RASTREIO_CHUVA && (
        <Toggle
          label="Rastreio da chuva"
          checked={chuva}
          onChange={(on) => useRastreioChuvaStore.getState().setLigado(on)}
          description="Áreas com chuva de 0,1 mm/h ou mais (GSMaP), de 30 em 30 min. Toque numa área para ver a ficha dela."
        />
      )}
      {/* No celular o painel é a folha do botão de rastreio do mapa: abre por cima desta. */}
      {(mobile || !aberto) && (
        <Button
          size="sm"
          icon={PanelRightOpen}
          className="pointer-coarse:min-h-11"
          // O cartão flutua sobre o mapa: o painel lateral continua aberto.
          onClick={() => (mobile ? setFolhaAberta(true) : setPainelAberto(true))}
        >
          Abrir o painel de rastreio e previsão
        </Button>
      )}
    </Section>
  );
}
